export const unwrapResult = result => {
  if (result.status === 'fulfilled') {
    return result.value;
  }
  throw result.reason;
};